import { render } from "./logout-form.vue?vue&type=template&id=4e383a68"
import script from "./logout-form.vue?vue&type=script&lang=js"
export * from "./logout-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__